import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { LifecyclePluginInterface } from './definitions';
import { CAPACITOR_LIFECYCLE_PLUGIN } from '../pluginConstants';

const LifecyclePluginRaw = registerPlugin<LifecyclePluginInterface>(CAPACITOR_LIFECYCLE_PLUGIN);
const LifecyclePlugin = withBridgedStackTrace(LifecyclePluginRaw, CAPACITOR_LIFECYCLE_PLUGIN);

export * from './definitions';
export { LifecyclePlugin };
